import React from 'react'

export default function WayBillEdit() {
  return <div className='App-paper'>
  </div>
}